<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div>
                    <div class="content">
                        <div class="panel panel-sm">
                            <div class="panel-heading">
                                <h2>Prijzen aanpassen</h2>
                                <p>Selecteer het csv bestand om te importeren.</p>
                                <br />
                                <strong>Belangrijk! Lees dit eerst.</strong>
                                <br />
                                Mocht je een .xls(x) bestand hebben. Sla deze dan eerst op als .csv bestand via Microsoft Excel
                                <br />
                                Er zijn een paar eisen waar dit bestand aan moet voldoen.
                                <li>Er mogen maar 2 kolommen bestaan in deze volgorde (<strong>artikelnummer</strong> en <strong>prijs</strong>)</li>
                                <li>Boven deze kolommen moet ook de titel staan respectievelijk <strong>artikelnummer</strong> en <strong>prijs</strong></li>
                                <li>Zorg dat de prijzen met decimalen zijn aangegeven met een punt (.) en niet met een komma (,) <strong>bijvoorbeeld:</strong> €4.50 = 4.5</li>
                                <li>Bij de prijzen mag er <strong>geen</strong> € teken staan (deze voeg ik zelf toe)</li>
                                <br />
                                <br />
                                Wanneer je een .csv bestand hebt geselecteerd zul je de wijzigingen hieronder in een tabel staan. Controleer of ze kloppen en of er geen gekke dingen in voorkomen.

                            </div>
                            <div class="panel-body">
                                <div class="form-group">
                                    <label for="csv_file" class="control-label col-sm-3 text-right">CSV bestand</label>
                                    <div class="col-sm-9">
                                        <input type="file" id="csv_file" name="csv_file" class="form-control" @change="loadCSV($event)">
                                    </div>
                                </div>
                                <br />
                                <br />

                                <table v-if="parse_csv.length > 0" class="table">
                                    <thead>
                                        <tr>
                                            <th v-for="key in parse_header"
                                                :class="{ active: sortKey == key }">
                                                {{ key }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tr v-for="csv in parse_csv">
                                        <td>
                                            {{csv.artikelnummer}}
                                        </td>
                                        <td>
                                            €{{csv.prijs}}
                                        </td>
                                    </tr>
                                </table>
                                <div class="col-sm-4" v-if="parse_csv.length > 0">
                                    <button type="button" class="btn btn-danger" @click="submit()">Verwerken</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bt-footer />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import BtFooter from './BTFooter.vue'

    export default {
        name: 'Prices',
        data() {
            return {
                parse_header: [],
                parse_csv: [],
                sortOrders: {},
                sortKey: ''
            }
        },
        created() {
            document.title = 'Brabant-Tools | Prijzen aanpassen'
        },
        methods: {
            submit() {
                var _self = this
                this.$swal({
                    title: 'Let op!',
                    text: 'Je staat op het punt om prijswijzigingen door te voeren. Weet je zeker dat alles klopt?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Verwerken',
                    cancelButtonText: 'Annuleren'
                }).then((result) => {
                    if (result) {
                        this.$store.dispatch('changePrices', _self.parse_csv).then(() => {
                            if (this.arePricesChanged) {
                                _self.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Prijzen zijn verwerkt!' })
                                _self.parse_csv = []
                            } else {
                                _self.$notify({ group: 'danger', type: 'error', title: 'Error', text: 'Er is iets misgegaan tijdens het verwerken van de prijzen!' })
                            }
                        })
                    }
                })
            },
            csvJSON(csv) {
                var vm = this
                var lines = csv.split('\n')
                var result = []
                var headers = lines[0].split(';')
                vm.parse_header = lines[0].split(';')

                lines.filter(function (line) {
                    if (line === '') {
                        return false;
                    }
                    return true;
                }).map(function (line, indexLine) {
                    if (indexLine < 1) return

                    var obj = {}

                    var currentline = line.split(';')

                    headers.map(function (header, indexHeader) {
                        switch (indexHeader) {
                            case 0:
                                obj.artikelnummer = currentline[indexHeader]
                                break;
                            case 1:
                                obj.prijs = parseFloat(parseFloat(currentline[indexHeader].replace(',', '.').trim()).toFixed(2))
                                break;
                        }
                    })
                    if (obj.artikelnummer)
                        result.push(obj)
                })
                return result
            },
            loadCSV(e) {
                var vm = this
                if (window.FileReader) {
                    var reader = new FileReader()
                    reader.readAsText(e.target.files[0])
                    // Handle errors load
                    reader.onload = function (event) {
                        var csv = event.target.result
                        vm.parse_csv = vm.csvJSON(csv)
                    }
                    reader.onerror = function (evt) {
                        if (evt.target.error.name === 'NotReadableError') {
                            alert('Cannot read file!')
                        }
                    }
                } else {
                    alert('FileReader are not supported in this browser.')
                }
            }
        },
        computed: {
            ...mapGetters({
                arePricesChanged: 'arePricesChanged'
            })
        },
        components: {
            BtFooter
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
